import { usePermissions } from "@/hooks/use-permissions";
import { useLocalization } from "@/context/localization-context";
import { MonitoringProvider } from "@/monitoring/monitoring-context";
import { MonitoringBoard } from "@/monitoring/monitoring-board";

/** Developer monitoring board (developer role only; the backend enforces the same). */
export default function MonitoringPage() {
  const { isDeveloper } = usePermissions();
  const { t } = useLocalization();

  if (!isDeveloper) {
    return (
      <div className="p-4 lg:p-6">
        <div className="rounded-md border border-dashed p-6 text-sm text-muted-foreground">{t("monitoring.forbidden")}</div>
      </div>
    );
  }

  return (
    <MonitoringProvider>
      <MonitoringBoard />
    </MonitoringProvider>
  );
}
